module.exports = [
	{
		"fund_family_label": "Vanguard",
		"net_assets": 7237066103108,
		"asset_rank": 1,
		"num_funds": 112,
		"sri": 6,
		"gef_num_funds": 110,
		"gef_score_norm": 53.717197759135914,
		"gef_score": 51.86033434163323,
		"gef_score_rank": 4,
		"dei_num_funds": 91,
		"dei_score_norm": 33.69830089688009,
		"dei_score": 27.887741939376546,
		"dei_score_rank": 4,
		"rji_num_funds": 91,
		"rji_score_norm": 24.722623879079517,
		"rji_score": 20.923018336736796,
		"rji_score_rank": 4,
		"hrc_num_funds": 73,
		"hrc_score_norm": 88.29266884263546,
		"hrc_score": 84.82115772899255,
		"hrc_score_rank": 4,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"net_assets": 3020567708403,
		"asset_rank": 2,
		"num_funds": 360,
		"sri": 31,
		"gef_num_funds": 340,
		"gef_score_norm": 53.49744127308338,
		"gef_score": 52.40089031563485,
		"gef_score_rank": 5,
		"dei_num_funds": 273,
		"dei_score_norm": 33.92178718865351,
		"dei_score": 29.171646658004196,
		"dei_score_rank": 3,
		"rji_num_funds": 273,
		"rji_score_norm": 24.60147779766859,
		"rji_score": 21.87974755325576,
		"rji_score_rank": 5,
		"hrc_num_funds": 234,
		"hrc_score_norm": 89.61488575179027,
		"hrc_score": 86.97917070437303,
		"hrc_score_rank": 2,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"net_assets": 2539296605702,
		"asset_rank": 3,
		"num_funds": 349,
		"sri": 45,
		"gef_num_funds": 296,
		"gef_score_norm": 52.87168381300949,
		"gef_score": 52.69926346792604,
		"gef_score_rank": 7,
		"dei_num_funds": 219,
		"dei_score_norm": 31.42614792086289,
		"dei_score": 28.961016676857664,
		"dei_score_rank": 8,
		"rji_num_funds": 219,
		"rji_score_norm": 23.20400113467522,
		"rji_score": 21.035601869162672,
		"rji_score_rank": 9,
		"hrc_num_funds": 177,
		"hrc_score_norm": 86.66165235504431,
		"hrc_score": 86.00921115409432,
		"hrc_score_rank": 8,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"net_assets": 2068405007327,
		"asset_rank": 4,
		"num_funds": 43,
		"sri": 0,
		"gef_num_funds": 41,
		"gef_score_norm": 54.57852027746957,
		"gef_score": 54.64619328895412,
		"gef_score_rank": 1,
		"dei_num_funds": 33,
		"dei_score_norm": 36.18708920673239,
		"dei_score": 35.15447230605117,
		"dei_score_rank": 1,
		"rji_num_funds": 33,
		"rji_score_norm": 25.34697535610521,
		"rji_score": 24.92856828295376,
		"rji_score_rank": 1,
		"hrc_num_funds": 32,
		"hrc_score_norm": 90.06165572477285,
		"hrc_score": 89.83973543233057,
		"hrc_score_rank": 1,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "State Street",
		"net_assets": 1252520583386,
		"asset_rank": 5,
		"num_funds": 118,
		"sri": 6,
		"gef_num_funds": 108,
		"gef_score_norm": 54.046077656895655,
		"gef_score": 50.71631987780661,
		"gef_score_rank": 2,
		"dei_num_funds": 94,
		"dei_score_norm": 35.38553558283076,
		"dei_score": 25.27006406971573,
		"dei_score_rank": 2,
		"rji_num_funds": 94,
		"rji_score_norm": 25.23586259579141,
		"rji_score": 18.50599230484021,
		"rji_score_rank": 2,
		"hrc_num_funds": 70,
		"hrc_score_norm": 87.55402866876125,
		"hrc_score": 81.0053409058594,
		"hrc_score_rank": 6,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"net_assets": 738671532755,
		"asset_rank": 6,
		"num_funds": 102,
		"sri": 1,
		"gef_num_funds": 93,
		"gef_score_norm": 52.85248154018526,
		"gef_score": 52.07203630550074,
		"gef_score_rank": 8,
		"dei_num_funds": 83,
		"dei_score_norm": 32.655464653764945,
		"dei_score": 29.871935670520944,
		"dei_score_rank": 7,
		"rji_num_funds": 83,
		"rji_score_norm": 24.133100246128667,
		"rji_score": 21.934609120124634,
		"rji_score_rank": 6,
		"hrc_num_funds": 68,
		"hrc_score_norm": 88.05062935849797,
		"hrc_score": 86.86677397217326,
		"hrc_score_rank": 5,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Invesco",
		"net_assets": 728468689560,
		"asset_rank": 7,
		"num_funds": 199,
		"sri": 14,
		"gef_num_funds": 185,
		"gef_score_norm": 52.38197626689238,
		"gef_score": 49.69859360504009,
		"gef_score_rank": 9,
		"dei_num_funds": 165,
		"dei_score_norm": 33.46176926004434,
		"dei_score": 23.27203227447033,
		"dei_score_rank": 5,
		"rji_num_funds": 165,
		"rji_score_norm": 24.75843299915598,
		"rji_score": 17.50884709415002,
		"rji_score_rank": 3,
		"hrc_num_funds": 116,
		"hrc_score_norm": 86.48498038038765,
		"hrc_score": 80.3378302546355,
		"hrc_score_rank": 9,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"net_assets": 684599999986,
		"asset_rank": 8,
		"num_funds": 11,
		"sri": 0,
		"gef_num_funds": 11,
		"gef_score_norm": 53.08348264669608,
		"gef_score": 53.47330955017773,
		"gef_score_rank": 6,
		"dei_num_funds": 10,
		"dei_score_norm": 31.379205270713197,
		"dei_score": 30.154017948863412,
		"dei_score_rank": 9,
		"rji_num_funds": 10,
		"rji_score_norm": 23.26007941107383,
		"rji_score": 22.564308530558115,
		"rji_score_rank": 8,
		"hrc_num_funds": 8,
		"hrc_score_norm": 89.28378461564493,
		"hrc_score": 88.41477248868775,
		"hrc_score_rank": 3,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "Schwab Funds",
		"net_assets": 551204588107,
		"asset_rank": 9,
		"num_funds": 61,
		"sri": 1,
		"gef_num_funds": 58,
		"gef_score_norm": 53.76647589334987,
		"gef_score": 52.575222281382594,
		"gef_score_rank": 3,
		"dei_num_funds": 48,
		"dei_score_norm": 32.69564003356232,
		"dei_score": 29.41486131756896,
		"dei_score_rank": 6,
		"rji_num_funds": 48,
		"rji_score_norm": 23.530520317993435,
		"rji_score": 21.9086117946788,
		"rji_score_rank": 7,
		"hrc_num_funds": 37,
		"hrc_score_norm": 87.46567460567162,
		"hrc_score": 87.69743673675335,
		"hrc_score_rank": 7,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 927
// module chunks = 0